import { render, staticRenderFns } from "./QuickDesign.vue?vue&type=template&id=b665ffea&scoped=true"
import script from "./QuickDesign.vue?vue&type=script&lang=js"
export * from "./QuickDesign.vue?vue&type=script&lang=js"
import style0 from "./QuickDesign.vue?vue&type=style&index=0&id=b665ffea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b665ffea",
  null
  
)

export default component.exports